import { DoorLockIcon, PlaneCrashIcon } from './mapIcons';
import { MAPS } from './TacticalMap';
import './TopBar.css';

interface TopBarProps {
  mapId: string;
  onMapChange: (mapId: string) => void;
  showCrashes: boolean;
  showLoot: boolean;
  onToggleCrashes: () => void;
  onToggleLoot: () => void;
  crashCount: number;
  lootCount: number;
}

/**
 * TopBar
 * props:
 *   mapId, onMapChange
 *   showCrashes, showLoot, onToggleCrashes, onToggleLoot
 *   crashCount, lootCount
 */
export default function TopBar({
  mapId,
  onMapChange,
  showCrashes,
  showLoot,
  onToggleCrashes,
  onToggleLoot,
  crashCount,
  lootCount,
}: TopBarProps) {
  return (
    <div className="tac-topbar">
      <div className="tac-brand">
        <div className="tac-brand-mark" />
        <div className="tac-brand-text">
          Tac-Map <span>/ {MAPS[mapId]?.label?.toLowerCase()}</span>
        </div>
      </div>

      <div className="tac-divider" />

      <div className="tac-map-select">
        <select value={mapId} onChange={(e) => onMapChange(e.target.value)}>
          {Object.entries(MAPS).map(([id, m]) => (
            <option key={id} value={id} disabled={!m.available}>
              {m.label}
            </option>
          ))}
        </select>
      </div>

      <div className="tac-layers">
        <label className={`tac-layer-toggle ${showCrashes ? '' : 'off'}`}>
          <input type="checkbox" checked={showCrashes} onChange={onToggleCrashes} />
          <span className="tac-swatch crash"><PlaneCrashIcon size={9} color="currentColor" /></span>
          <span className="tac-layer-label">Крушения самолётов</span>
          <span className="tac-layer-count">{crashCount}</span>
        </label>
        <label className={`tac-layer-toggle ${showLoot ? '' : 'off'}`}>
          <input type="checkbox" checked={showLoot} onChange={onToggleLoot} />
          <span className="tac-swatch loot"><DoorLockIcon size={9} color="currentColor" /></span>
          <span className="tac-layer-label">Контейнеры (замки)</span>
          <span className="tac-layer-count">{lootCount}</span>
        </label>
      </div>
    </div>
  );
}
